import { GetServerSideProps } from "next";

import { getParam } from "shared/lib/next";
import { NextPageWithLayout } from "shared/types";

import { StandardLayout } from "~/components/layouts";
import { ProductRankingShowPage } from "~/features/rankings";

type Props = {
  id: string;
};

const Page: NextPageWithLayout<Props> = ({
  id,
}) => {
  return (
    <>
      <ProductRankingShowPage id={id} />
    </>
  );
};

Page.getLayout = (page) => <StandardLayout>{page}</StandardLayout>;

export const getServerSideProps: GetServerSideProps<Props> = async (context) => {
  const { params = {} } = context;
  const id = getParam(params, "id");

  return {
    props: {
      id,
    },
  };
};

export default Page;
